import type { UserRole } from './enums';

/**
 * Permisos de la aplicación. La autorización se comprueba SIEMPRE en el servidor;
 * la web solo los usa para ocultar opciones no disponibles.
 * Añadir un rol nuevo = añadir su entrada en ROLE_PERMISSIONS.
 */
export const PERMISSIONS = [
  'pallets.read',
  'pallets.entry',
  'pallets.locate',
  'pallets.edit',
  'pallets.cancel',
  'outbound.manage',
  'clients.read',
  'clients.manage',
  'products.read',
  'products.manage',
  'locations.read',
  'locations.manage',
  'rates.read',
  'rates.manage',
  'billing.read',
  'billing.manage',
  'users.manage',
  'settings.manage',
  'audit.read',
] as const;
export type Permission = (typeof PERMISSIONS)[number];

const OPERATOR_PERMISSIONS: readonly Permission[] = [
  'pallets.read',
  'pallets.entry',
  'pallets.locate',
  'outbound.manage',
  'clients.read',
  'products.read',
  // Permite dar de alta una mercancía nueva durante la recepción.
  'products.manage',
  'locations.read',
];

const OFFICE_PERMISSIONS: readonly Permission[] = [
  'pallets.read',
  'pallets.edit',
  'clients.read',
  'clients.manage',
  'products.read',
  'products.manage',
  'locations.read',
  'rates.read',
  'rates.manage',
  'billing.read',
  'billing.manage',
  'audit.read',
];

export const ROLE_PERMISSIONS: Record<UserRole, readonly Permission[]> = {
  ADMIN: PERMISSIONS,
  OFFICE: OFFICE_PERMISSIONS,
  OPERATOR: OPERATOR_PERMISSIONS,
};

export function hasPermission(role: UserRole, permission: Permission): boolean {
  return ROLE_PERMISSIONS[role].includes(permission);
}
